import { Component, Input, OnInit } from "@angular/core";
import { BreadcrumbsViewModel } from "src/domain/client";
import { BrandService } from "src/services/brand.service";

@Component({
  selector: "vw-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
})
export class BreadcrumbsComponent implements OnInit {
  constructor(private brandService: BrandService) {}
  @Input() currentPage?: string;
  @Input() breadcrumbs: BreadcrumbsViewModel[] = [];

  brandShort?: string;

  ngOnInit(): void {
    if (this.brandService.brand?.urlShort)
      this.brandShort = this.brandService.brand.urlShort;
  }
}
